let data = [
  {
    id: 282,
    user_id: 876,
    name: null,
    comment: null,
    start_at: '26.11.2020 00:00:00',
    end_at: null,
    sum: null,
    future_sum: 182984329.17177832,
    start_sum: 0,
    percent: 0,
    percent_sum: 13,
    payment_per_period: 0,
    currency_id: 1,
    period_type_id: 3,
    type_id: 4,
    next_period_id: 1,
    calc_type_id: null,
    count: 1,
    data: [
      {
        end_at: '2059-07-07',
        payment_per_period: '2668.3281',
        count_payments: '464',
        sum_payments: '21013084.790099967',
        future_sum: '182984329.17177832',
        achive_goal: false,
      },
    ],
    payments: {
      aim_payments_index: [
        '2020-11-30',
        '2020-12-31',
        '2021-01-29',
        '2021-02-26',
        '2021-03-31',
        '2021-04-30',
        '2021-05-31',
        '2021-06-30',
        '2021-07-30',
        '2021-08-31',
        '2021-09-30',
        '2021-10-29',
        '2021-11-30',
        '2021-12-31',
        '2022-01-31',
        '2022-02-28',
        '2022-03-31',
        '2022-04-29',
        '2022-05-31',
        '2022-06-30',
        '2022-07-29',
        '2022-08-31',
        '2022-09-30',
        '2022-10-31',
        '2022-11-30',
        '2022-12-30',
        '2023-01-31',
        '2023-02-28',
        '2023-03-31',
        '2023-04-28',
        '2023-05-31',
        '2023-06-30',
        '2023-07-31',
        '2023-08-31',
        '2023-09-29',
        '2023-10-31',
        '2023-11-30',
        '2023-12-29',
        '2024-01-31',
        '2024-02-28',
        '2024-03-29',
        '2024-04-30',
        '2024-05-31',
        '2024-06-28',
        '2024-07-31',
        '2024-08-30',
        '2024-09-30',
        '2024-10-31',
        '2024-11-29',
        '2024-12-31',
        '2025-01-31',
        '2025-02-28',
        '2025-03-31',
        '2025-04-30',
        '2025-05-30',
        '2025-06-30',
        '2025-07-31',
        '2025-08-29',
        '2025-09-30',
        '2025-10-31',
        '2025-11-28',
        '2025-12-31',
        '2026-01-30',
        '2026-02-27',
        '2026-03-31',
        '2026-04-30',
        '2026-05-29',
        '2026-06-30',
        '2026-07-31',
        '2026-08-31',
        '2026-09-30',
        '2026-10-30',
        '2026-11-30',
        '2026-12-31',
        '2027-01-29',
        '2027-02-26',
        '2027-03-31',
        '2027-04-30',
        '2027-05-31',
        '2027-06-30',
        '2027-07-30',
        '2027-08-31',
        '2027-09-30',
        '2027-10-29',
        '2027-11-30',
        '2027-12-31',
        '2028-01-31',
        '2028-02-28',
        '2028-03-31',
        '2028-04-28',
        '2028-05-31',
        '2028-06-30',
        '2028-07-31',
        '2028-08-31',
        '2028-09-29',
        '2028-10-31',
        '2028-11-30',
        '2028-12-29',
        '2029-01-31',
        '2029-02-28',
        '2029-03-30',
        '2029-04-30',
        '2029-05-31',
        '2029-06-29',
        '2029-07-31',
        '2029-08-31',
        '2029-09-28',
        '2029-10-31',
        '2029-11-30',
        '2029-12-31',
        '2030-01-31',
        '2030-02-28',
        '2030-03-29',
        '2030-04-30',
        '2030-05-31',
        '2030-06-28',
        '2030-07-31',
        '2030-08-30',
        '2030-09-30',
        '2030-10-31',
        '2030-11-29',
        '2030-12-31',
        '2031-01-31',
        '2031-02-28',
        '2031-03-31',
        '2031-04-30',
        '2031-05-30',
        '2031-06-30',
        '2031-07-31',
        '2031-08-29',
        '2031-09-30',
        '2031-10-31',
        '2031-11-28',
        '2031-12-31',
        '2032-01-30',
        '2032-02-27',
        '2032-03-31',
        '2032-04-30',
        '2032-05-31',
        '2032-06-30',
        '2032-07-30',
        '2032-08-31',
        '2032-09-30',
        '2032-10-29',
        '2032-11-30',
        '2032-12-31',
        '2033-01-31',
        '2033-02-28',
        '2033-03-31',
        '2033-04-29',
        '2033-05-31',
        '2033-06-30',
        '2033-07-29',
        '2033-08-31',
        '2033-09-30',
        '2033-10-31',
        '2033-11-30',
        '2033-12-30',
        '2034-01-31',
        '2034-02-28',
        '2034-03-31',
        '2034-04-28',
        '2034-05-31',
        '2034-06-30',
        '2034-07-31',
        '2034-08-31',
        '2034-09-29',
        '2034-10-31',
        '2034-11-30',
        '2034-12-29',
        '2035-01-31',
        '2035-02-28',
        '2035-03-30',
        '2035-04-30',
        '2035-05-31',
        '2035-06-29',
        '2035-07-31',
        '2035-08-31',
        '2035-09-28',
        '2035-10-31',
        '2035-11-30',
        '2035-12-31',
        '2036-01-31',
        '2036-02-28',
        '2036-03-31',
        '2036-04-30',
        '2036-05-30',
        '2036-06-30',
        '2036-07-31',
        '2036-08-29',
        '2036-09-30',
        '2036-10-31',
        '2036-11-28',
        '2036-12-31',
        '2037-01-30',
        '2037-02-27',
        '2037-03-31',
        '2037-04-30',
        '2037-05-29',
        '2037-06-30',
        '2037-07-31',
        '2037-08-31',
        '2037-09-30',
        '2037-10-30',
        '2037-11-30',
        '2037-12-31',
        '2038-01-29',
        '2038-02-26',
        '2038-03-31',
        '2038-04-30',
        '2038-05-31',
        '2038-06-30',
        '2038-07-30',
        '2038-08-31',
        '2038-09-30',
        '2038-10-29',
        '2038-11-30',
        '2038-12-31',
        '2039-01-31',
        '2039-02-28',
        '2039-03-31',
        '2039-04-29',
        '2039-05-31',
        '2039-06-30',
        '2039-07-29',
        '2039-08-31',
        '2039-09-30',
        '2039-10-31',
        '2039-11-30',
        '2039-12-30',
        '2040-01-31',
        '2040-02-28',
        '2040-03-30',
        '2040-04-30',
        '2040-05-31',
        '2040-06-29',
        '2040-07-31',
        '2040-08-31',
        '2040-09-28',
        '2040-10-31',
        '2040-11-30',
        '2040-12-31',
        '2041-01-31',
        '2041-02-28',
        '2041-03-29',
        '2041-04-30',
        '2041-05-31',
        '2041-06-28',
        '2041-07-31',
        '2041-08-30',
        '2041-09-30',
        '2041-10-31',
        '2041-11-29',
        '2041-12-31',
        '2042-01-31',
        '2042-02-28',
        '2042-03-31',
        '2042-04-30',
        '2042-05-30',
        '2042-06-30',
        '2042-07-31',
        '2042-08-29',
        '2042-09-30',
        '2042-10-31',
        '2042-11-28',
        '2042-12-31',
        '2043-01-30',
        '2043-02-27',
        '2043-03-31',
        '2043-04-30',
        '2043-05-29',
        '2043-06-30',
        '2043-07-31',
        '2043-08-31',
        '2043-09-30',
        '2043-10-30',
        '2043-11-30',
        '2043-12-31',
        '2044-01-29',
        '2044-02-26',
        '2044-03-31',
        '2044-04-29',
        '2044-05-31',
        '2044-06-30',
        '2044-07-29',
        '2044-08-31',
        '2044-09-30',
        '2044-10-31',
        '2044-11-30',
        '2044-12-30',
        '2045-01-31',
        '2045-02-28',
        '2045-03-31',
        '2045-04-28',
        '2045-05-31',
        '2045-06-30',
        '2045-07-31',
        '2045-08-31',
        '2045-09-29',
        '2045-10-31',
        '2045-11-30',
        '2045-12-29',
        '2046-01-31',
        '2046-02-28',
        '2046-03-30',
        '2046-04-30',
        '2046-05-31',
        '2046-06-29',
        '2046-07-31',
        '2046-08-31',
        '2046-09-28',
        '2046-10-31',
        '2046-11-30',
        '2046-12-31',
        '2047-01-31',
        '2047-02-28',
        '2047-03-29',
        '2047-04-30',
        '2047-05-31',
        '2047-06-28',
        '2047-07-31',
        '2047-08-30',
        '2047-09-30',
        '2047-10-31',
        '2047-11-29',
        '2047-12-31',
        '2048-01-31',
        '2048-02-28',
        '2048-03-31',
        '2048-04-30',
        '2048-05-29',
        '2048-06-30',
        '2048-07-31',
        '2048-08-31',
        '2048-09-30',
        '2048-10-30',
        '2048-11-30',
        '2048-12-31',
        '2049-01-29',
        '2049-02-26',
        '2049-03-31',
        '2049-04-30',
        '2049-05-31',
        '2049-06-30',
        '2049-07-30',
        '2049-08-31',
        '2049-09-30',
        '2049-10-29',
        '2049-11-30',
        '2049-12-31',
        '2050-01-31',
        '2050-02-28',
        '2050-03-31',
        '2050-04-29',
        '2050-05-31',
        '2050-06-30',
        '2050-07-29',
        '2050-08-31',
        '2050-09-30',
        '2050-10-31',
        '2050-11-30',
        '2050-12-30',
        '2051-01-31',
        '2051-02-28',
        '2051-03-31',
        '2051-04-28',
        '2051-05-31',
        '2051-06-30',
        '2051-07-31',
        '2051-08-31',
        '2051-09-29',
        '2051-10-31',
        '2051-11-30',
        '2051-12-29',
        '2052-01-31',
        '2052-02-28',
        '2052-03-29',
        '2052-04-30',
        '2052-05-31',
        '2052-06-28',
        '2052-07-31',
        '2052-08-30',
        '2052-09-30',
        '2052-10-31',
        '2052-11-29',
        '2052-12-31',
        '2053-01-31',
        '2053-02-28',
        '2053-03-31',
        '2053-04-30',
        '2053-05-30',
        '2053-06-30',
        '2053-07-31',
        '2053-08-29',
        '2053-09-30',
        '2053-10-31',
        '2053-11-28',
        '2053-12-31',
        '2054-01-30',
        '2054-02-27',
        '2054-03-31',
        '2054-04-30',
        '2054-05-29',
        '2054-06-30',
        '2054-07-31',
        '2054-08-31',
        '2054-09-30',
        '2054-10-30',
        '2054-11-30',
        '2054-12-31',
        '2055-01-29',
        '2055-02-26',
        '2055-03-31',
        '2055-04-30',
        '2055-05-31',
        '2055-06-30',
        '2055-07-30',
        '2055-08-31',
        '2055-09-30',
        '2055-10-29',
        '2055-11-30',
        '2055-12-31',
        '2056-01-31',
        '2056-02-28',
        '2056-03-31',
        '2056-04-28',
        '2056-05-31',
        '2056-06-30',
        '2056-07-31',
        '2056-08-31',
        '2056-09-29',
        '2056-10-31',
        '2056-11-30',
        '2056-12-29',
        '2057-01-31',
        '2057-02-28',
        '2057-03-30',
        '2057-04-30',
        '2057-05-31',
        '2057-06-29',
        '2057-07-31',
        '2057-08-31',
        '2057-09-28',
        '2057-10-31',
        '2057-11-30',
        '2057-12-31',
        '2058-01-31',
        '2058-02-28',
        '2058-03-29',
        '2058-04-30',
        '2058-05-31',
        '2058-06-28',
        '2058-07-31',
        '2058-08-30',
        '2058-09-30',
        '2058-10-31',
        '2058-11-29',
        '2058-12-31',
        '2059-01-31',
        '2059-02-28',
        '2059-03-31',
        '2059-04-30',
        '2059-05-30',
        '2059-06-30',
      ],
      aim_payments_values: [
        2795.7481, 2795.7481, 9554.9972, 9554.9972, 9554.9972, 9554.9972, 9554.9972, 9554.9972,
        9554.9972, 9554.9972, 9554.9972, 9554.9972, 9554.9972, 9558.6006, 8446.7627, 8446.7627,
        6646.6737, 6646.6737, 6646.6737, 6646.6737, 6646.6737, 6646.6737, 6646.6737, 6646.6737,
        6646.6737, 6649.0345, 7071.7516, 7071.7516, 7071.7516, 7071.7516, 7071.7516, 7071.7516,
        7071.7516, 7071.7516, 7071.7516, 7071.7516, 7071.7516, 7073.367, 7701.1056, 7701.1056,
        7701.1056, 7701.1056, 7701.1056, 7701.1056, 7701.1056, 7701.1056, 7701.1056, 7701.1056,
        7701.1056, 7705.5788, 8375.6885, 8375.6885, 8375.6885, 8375.6885, 8375.6885, 8375.6885,
        8375.6885, 8375.6885, 8375.6885, 8375.6885, 8375.6885, 10649.0666, 11562.5929, 11562.5929,
        11562.5929, 11562.5929, 11562.5929, 11562.5929, 11562.5929, 11562.5929, 11562.5929,
        11562.5929, 11562.5929, 11565.2022, 12546.4477, 12546.4477, 12546.4477, 12546.4477,
        12546.4477, 12546.4477, 12546.4477, 12546.4477, 12546.4477, 12546.4477, 12546.4477,
        12552.5362, 13601.1281, 13601.1281, 13601.1281, 13601.1281, 13601.1281, 13601.1281,
        13601.1281, 13601.1281, 13601.1281, 13601.1281, 13601.1281, 13606.9681, 14731.4801,
        14731.4801, 14731.4801, 14731.4801, 14731.4801, 14731.4801, 14731.4801, 14731.4801,
        14731.4801, 14731.4801, 14731.4801, 14737.5687, 15943.7165, 15943.7165, 15943.7165,
        15943.7165, 15943.7165, 15943.7165, 15943.7165, 15943.7165, 15943.7165, 15943.7165,
        15943.7165, 15947.0714, 17243.1802, 17243.1802, 17243.1802, 17243.1802, 17243.1802,
        17243.1802, 17243.1802, 17243.1802, 17243.1802, 17243.1802, 17243.1802, 17247.2807,
        18636.9539, 18636.9539, 18636.9539, 18636.9539, 18636.9539, 18636.9539, 18636.9539,
        18636.9539, 18636.9539, 18636.9539, 18636.9539, 18641.0543, 20131.7472, 20131.7472,
        20131.7472, 20131.7472, 20131.7472, 20131.7472, 20131.7472, 20131.7472, 20131.7472,
        20131.7472, 20131.7472, 20135.9719, 21735.1398, 21735.1398, 21735.1398, 21735.1398,
        21735.1398, 21735.1398, 21735.1398, 21735.1398, 21735.1398, 21735.1398, 21735.1398,
        21741.4768, 24809.9657, 24809.9657, 24809.9657, 24809.9657, 24809.9657, 24809.9657,
        24809.9657, 24809.9657, 24809.9657, 24809.9657, 24809.9657, 24816.6755, 28010.5381,
        28010.5381, 28010.5381, 28010.5381, 28010.5381, 28010.5381, 28010.5381, 28010.5381,
        28010.5381, 28010.5381, 28010.5381, 28019.236, 29992.4129, 29992.4129, 29992.4129,
        29992.4129, 29992.4129, 29992.4129, 29992.4129, 29992.4129, 29992.4129, 29992.4129,
        29992.4129, 29998.1286, 32119.418, 32119.418, 32119.418, 32119.418, 32119.418, 32119.418,
        32119.418, 32119.418, 32119.418, 32119.418, 32119.418, 32127.1219, 34403.2336, 34403.2336,
        34403.2336, 34403.2336, 34403.2336, 34403.2336, 34403.2336, 34403.2336, 34403.2336,
        34403.2336, 34403.2336, 34410.4404, 36855.4153, 36855.4153, 36855.4153, 36855.4153,
        36855.4153, 36855.4153, 36855.4153, 36855.4153, 36855.4153, 36855.4153, 36855.4153,
        36863.9889, 39489.1343, 39489.1343, 39489.1343, 39489.1343, 39489.1343, 39489.1343,
        39489.1343, 39489.1343, 39489.1343, 39489.1343, 39489.1343, 39496.9624, 42318.1828,
        42318.1828, 42318.1828, 42318.1828, 42318.1828, 42318.1828, 42318.1828, 42318.1828,
        42318.1828, 42318.1828, 42318.1828, 42324.0228, 45357.2231, 45357.2231, 45357.2231,
        45357.2231, 45357.2231, 45357.2231, 45357.2231, 45357.2231, 45357.2231, 45357.2231,
        45357.2231, 45363.0632, 48622.1599, 48622.1599, 48622.1599, 48622.1599, 48622.1599,
        48622.1599, 48622.1599, 48622.1599, 48622.1599, 48622.1599, 48622.1599, 48632.5974,
        52131.1344, 52131.1344, 52131.1344, 52131.1344, 52131.1344, 52131.1344, 52131.1344,
        52131.1344, 52131.1344, 52131.1344, 52131.1344, 52141.9446, 55902.6607, 55902.6607,
        55902.6607, 55902.6607, 55902.6607, 55902.6607, 55902.6607, 55902.6607, 55902.6607,
        55902.6607, 55902.6607, 55912.6012, 59956.744, 59956.744, 59956.744, 59956.744, 59956.744,
        59956.744, 59956.744, 59956.744, 59956.744, 59956.744, 59956.744, 59967.43, 64315.6259,
        64315.6259, 64315.6259, 64315.6259, 64315.6259, 64315.6259, 64315.6259, 64315.6259,
        64315.6259, 64315.6259, 64315.6259, 64323.951, 69002.1695, 69002.1695, 69002.1695,
        69002.1695, 69002.1695, 69002.1695, 69002.1695, 69002.1695, 69002.1695, 69002.1695,
        69002.1695, 69013.9738, 74042.5927, 74042.5927, 74042.5927, 74042.5927, 74042.5927,
        74042.5927, 74042.5927, 74042.5927, 74042.5927, 74042.5927, 74042.5927, 74054.6455,
        79464.1074, 79464.1074, 79464.1074, 79464.1074, 79464.1074, 79464.1074, 79464.1074,
        79464.1074, 79464.1074, 79464.1074, 79464.1074, 79476.4087, 85296.4107, 85296.4107,
        85296.4107, 85296.4107, 85296.4107, 85296.4107, 85296.4107, 85296.4107, 85296.4107,
        85296.4107, 85296.4107, 85309.0848, 91571.809, 91571.809, 91571.809, 91571.809, 91571.809,
        91571.809, 91571.809, 91571.809, 91571.809, 91571.809, 91571.809, 91581.998, 98324.3484,
        98324.3484, 98324.3484, 98324.3484, 98324.3484, 98324.3484, 98324.3484, 98324.3484,
        98324.3484, 98324.3484, 98324.3484, 98336.1526, 105591.5539, 105591.5539, 105591.5539,
        105591.5539, 105591.5539, 105591.5539, 105591.5539, 105591.5539, 105591.5539, 105591.5539,
        105591.5539, 105607.5828, 113414.6783, 113414.6783, 113414.6783, 113414.6783, 113414.6783,
        113414.6783, 113414.6783, 113414.6783, 113414.6783, 113414.6783, 113414.6783, 113427.3524,
        121836.3414, 121836.3414, 121836.3414, 121836.3414, 121836.3414, 121836.3414, 121836.3414,
        121836.3414, 121836.3414, 121836.3414, 121836.3414, 121850.755, 130904.0086, 130904.0086,
        130904.0086, 130904.0086, 130904.0086, 130904.0086, 130904.0086, 130904.0086, 130904.0086,
        130904.0086, 130904.0086, 130921.6529, 140668.9976, 140668.9976, 140668.9976, 140668.9976,
        140668.9976, 140668.9976,
      ],
    },
    inflation: 8,
    spending_per_period: 600000,
    spending_per_period_future: 11175165.37901229,
    order: 4,
    plan_type_id: 1,
    bind_type_id: 1,
    consider_type_id: 1,
    retire_id: 3,
    scenario_id: 4,
    portfolio_plan: null,
    advise: null,
    plan_fields: null,
    goal_payments: [
      {
        id: 37405,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2020 00:00:00',
        original_sum: 2795.7481,
        sum: 2795.7481,
        original_paid_sum: 1608.9,
        paid_sum: 1608.9,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37406,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2020 00:00:00',
        original_sum: 2795.7481,
        sum: 2795.7481,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37927,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37928,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37409,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37410,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37411,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37412,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37929,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37414,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37415,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37930,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37417,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2021 00:00:00',
        original_sum: 9554.9972,
        sum: 9554.9972,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37418,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2021 00:00:00',
        original_sum: 9558.6006,
        sum: 9558.6006,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37419,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2022 00:00:00',
        original_sum: 8446.7627,
        sum: 8446.7627,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37420,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2022 00:00:00',
        original_sum: 8446.7627,
        sum: 8446.7627,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37421,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37931,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37423,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37424,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37932,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37426,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37427,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37428,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37429,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2022 00:00:00',
        original_sum: 6646.6737,
        sum: 6646.6737,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37933,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2022 00:00:00',
        original_sum: 6649.0345,
        sum: 6649.0345,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37431,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37432,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37433,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37934,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37435,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37436,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37437,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37438,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37935,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37440,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37441,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2023 00:00:00',
        original_sum: 7071.7516,
        sum: 7071.7516,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37936,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2023 00:00:00',
        original_sum: 7073.367,
        sum: 7073.367,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37443,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37444,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37937,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37446,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37447,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37938,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37449,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37939,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37451,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37452,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37940,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2024 00:00:00',
        original_sum: 7701.1056,
        sum: 7701.1056,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37454,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2024 00:00:00',
        original_sum: 7705.5788,
        sum: 7705.5788,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37455,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37456,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37457,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37458,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37941,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37460,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37461,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37942,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37463,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37464,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37943,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2025 00:00:00',
        original_sum: 8375.6885,
        sum: 8375.6885,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37466,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2025 00:00:00',
        original_sum: 10649.0666,
        sum: 10649.0666,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37944,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37945,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37469,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37470,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37946,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37472,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37473,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37474,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37475,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37947,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37477,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2026 00:00:00',
        original_sum: 11562.5929,
        sum: 11562.5929,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37478,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2026 00:00:00',
        original_sum: 11565.2022,
        sum: 11565.2022,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37948,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37949,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37481,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37482,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37483,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37484,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37950,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37486,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37487,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37951,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37489,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2027 00:00:00',
        original_sum: 12546.4477,
        sum: 12546.4477,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37490,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2027 00:00:00',
        original_sum: 12552.5362,
        sum: 12552.5362,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37491,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37492,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37493,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37952,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37495,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37496,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37497,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37498,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37953,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37500,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37501,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2028 00:00:00',
        original_sum: 13601.1281,
        sum: 13601.1281,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37954,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2028 00:00:00',
        original_sum: 13606.9681,
        sum: 13606.9681,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37503,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37504,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37955,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37506,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37507,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37956,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37509,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37510,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37957,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37512,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37513,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2029 00:00:00',
        original_sum: 14731.4801,
        sum: 14731.4801,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37514,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2029 00:00:00',
        original_sum: 14737.5687,
        sum: 14737.5687,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37515,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37516,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37958,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37518,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37519,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37959,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37521,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37960,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37523,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37524,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37961,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2030 00:00:00',
        original_sum: 15943.7165,
        sum: 15943.7165,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37526,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2030 00:00:00',
        original_sum: 15947.0714,
        sum: 15947.0714,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37527,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37528,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37529,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37530,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37962,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37532,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37533,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37963,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37535,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37536,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37964,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2031 00:00:00',
        original_sum: 17243.1802,
        sum: 17243.1802,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37538,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2031 00:00:00',
        original_sum: 17247.2807,
        sum: 17247.2807,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37965,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37966,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37541,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37542,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37543,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37544,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37967,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37546,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37547,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37968,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37549,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2032 00:00:00',
        original_sum: 18636.9539,
        sum: 18636.9539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37550,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2032 00:00:00',
        original_sum: 18641.0543,
        sum: 18641.0543,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37551,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37552,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37553,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37969,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37555,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37556,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37970,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37558,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37559,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37560,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37561,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2033 00:00:00',
        original_sum: 20131.7472,
        sum: 20131.7472,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37971,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2033 00:00:00',
        original_sum: 20135.9719,
        sum: 20135.9719,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37563,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37564,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37565,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37972,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37567,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37568,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37569,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37570,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37973,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37572,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37573,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2034 00:00:00',
        original_sum: 21735.1398,
        sum: 21735.1398,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37974,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2034 00:00:00',
        original_sum: 21741.4768,
        sum: 21741.4768,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37575,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37576,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37975,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37578,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37579,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37976,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37581,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37582,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37977,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37584,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37585,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2035 00:00:00',
        original_sum: 24809.9657,
        sum: 24809.9657,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37586,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2035 00:00:00',
        original_sum: 24816.6755,
        sum: 24816.6755,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37587,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37588,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37589,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37590,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37978,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37592,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37593,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37979,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37595,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37596,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37980,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2036 00:00:00',
        original_sum: 28010.5381,
        sum: 28010.5381,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37598,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2036 00:00:00',
        original_sum: 28019.236,
        sum: 28019.236,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37981,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37982,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37601,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37602,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37983,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37604,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37605,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37606,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37607,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37984,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37609,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2037 00:00:00',
        original_sum: 29992.4129,
        sum: 29992.4129,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37610,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2037 00:00:00',
        original_sum: 29998.1286,
        sum: 29998.1286,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37985,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37986,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37613,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37614,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37615,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37616,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37987,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37618,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37619,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37988,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37621,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2038 00:00:00',
        original_sum: 32119.418,
        sum: 32119.418,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37622,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2038 00:00:00',
        original_sum: 32127.1219,
        sum: 32127.1219,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37623,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37624,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37625,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37989,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37627,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37628,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37990,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37630,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37631,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37632,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37633,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2039 00:00:00',
        original_sum: 34403.2336,
        sum: 34403.2336,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37991,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2039 00:00:00',
        original_sum: 34410.4404,
        sum: 34410.4404,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37635,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37636,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37992,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37638,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37639,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37993,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37641,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37642,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37994,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37644,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37645,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2040 00:00:00',
        original_sum: 36855.4153,
        sum: 36855.4153,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37646,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2040 00:00:00',
        original_sum: 36863.9889,
        sum: 36863.9889,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37647,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37648,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37995,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37650,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37651,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37996,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37653,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37997,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37655,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37656,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37998,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2041 00:00:00',
        original_sum: 39489.1343,
        sum: 39489.1343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37658,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2041 00:00:00',
        original_sum: 39496.9624,
        sum: 39496.9624,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37659,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37660,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37661,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37662,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37999,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37664,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37665,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38000,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37667,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37668,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38001,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2042 00:00:00',
        original_sum: 42318.1828,
        sum: 42318.1828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37670,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2042 00:00:00',
        original_sum: 42324.0228,
        sum: 42324.0228,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38002,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38003,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37673,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37674,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38004,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37676,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37677,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37678,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37679,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38005,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37681,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2043 00:00:00',
        original_sum: 45357.2231,
        sum: 45357.2231,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37682,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2043 00:00:00',
        original_sum: 45363.0632,
        sum: 45363.0632,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38006,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38007,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37685,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38008,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37687,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37688,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38009,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37690,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37691,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37692,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37693,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2044 00:00:00',
        original_sum: 48622.1599,
        sum: 48622.1599,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38010,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2044 00:00:00',
        original_sum: 48632.5974,
        sum: 48632.5974,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37695,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37696,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37697,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38011,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37699,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37700,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37701,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37702,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38012,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37704,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37705,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2045 00:00:00',
        original_sum: 52131.1344,
        sum: 52131.1344,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38013,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2045 00:00:00',
        original_sum: 52141.9446,
        sum: 52141.9446,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37707,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37708,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38014,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37710,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37711,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38015,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37713,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37714,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38016,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37716,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37717,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2046 00:00:00',
        original_sum: 55902.6607,
        sum: 55902.6607,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37718,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2046 00:00:00',
        original_sum: 55912.6012,
        sum: 55912.6012,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37719,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37720,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38017,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37722,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37723,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38018,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37725,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38019,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37727,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37728,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38020,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2047 00:00:00',
        original_sum: 59956.744,
        sum: 59956.744,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37730,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2047 00:00:00',
        original_sum: 59967.43,
        sum: 59967.43,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37731,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37732,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37733,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37734,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38021,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37736,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37737,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37738,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37739,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38022,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37741,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2048 00:00:00',
        original_sum: 64315.6259,
        sum: 64315.6259,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37742,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2048 00:00:00',
        original_sum: 64323.951,
        sum: 64323.951,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38023,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38024,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37745,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37746,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37747,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37748,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38025,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37750,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37751,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38026,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37753,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2049 00:00:00',
        original_sum: 69002.1695,
        sum: 69002.1695,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37754,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2049 00:00:00',
        original_sum: 69013.9738,
        sum: 69013.9738,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37755,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37756,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37757,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38027,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37759,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37760,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38028,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37762,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37763,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37764,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37765,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2050 00:00:00',
        original_sum: 74042.5927,
        sum: 74042.5927,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38029,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2050 00:00:00',
        original_sum: 74054.6455,
        sum: 74054.6455,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37767,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37768,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37769,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38030,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37771,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37772,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37773,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37774,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38031,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37776,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37777,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2051 00:00:00',
        original_sum: 79464.1074,
        sum: 79464.1074,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38032,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2051 00:00:00',
        original_sum: 79476.4087,
        sum: 79476.4087,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37779,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37780,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38033,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37782,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37783,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38034,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37785,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38035,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37787,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37788,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38036,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2052 00:00:00',
        original_sum: 85296.4107,
        sum: 85296.4107,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37790,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2052 00:00:00',
        original_sum: 85309.0848,
        sum: 85309.0848,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37791,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37792,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37793,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37794,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38037,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37796,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37797,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38038,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37799,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37800,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38039,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2053 00:00:00',
        original_sum: 91571.809,
        sum: 91571.809,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37802,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2053 00:00:00',
        original_sum: 91581.998,
        sum: 91581.998,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38040,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38041,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37805,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37806,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38042,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37808,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37809,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37810,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37811,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38043,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37813,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2054 00:00:00',
        original_sum: 98324.3484,
        sum: 98324.3484,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37814,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2054 00:00:00',
        original_sum: 98336.1526,
        sum: 98336.1526,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38044,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38045,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37817,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37818,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37819,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37820,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38046,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37822,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37823,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38047,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37825,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2055 00:00:00',
        original_sum: 105591.5539,
        sum: 105591.5539,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37826,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2055 00:00:00',
        original_sum: 105607.5828,
        sum: 105607.5828,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37827,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37828,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37829,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38048,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37831,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37832,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37833,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37834,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38049,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37836,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37837,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2056 00:00:00',
        original_sum: 113414.6783,
        sum: 113414.6783,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38050,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2056 00:00:00',
        original_sum: 113427.3524,
        sum: 113427.3524,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37839,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37840,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38051,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37842,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37843,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38052,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37845,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37846,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38053,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37848,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37849,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2057 00:00:00',
        original_sum: 121836.3414,
        sum: 121836.3414,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37850,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2057 00:00:00',
        original_sum: 121850.755,
        sum: 121850.755,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37851,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37852,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38054,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37854,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37855,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38055,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37857,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.07.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38056,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.08.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37859,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.09.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37860,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.10.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38057,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.11.2058 00:00:00',
        original_sum: 130904.0086,
        sum: 130904.0086,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37862,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.12.2058 00:00:00',
        original_sum: 130921.6529,
        sum: 130921.6529,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37863,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.01.2059 00:00:00',
        original_sum: 140668.9976,
        sum: 140668.9976,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37864,
        goal_id: 282,
        currency_id: 1,
        paid_at: '28.02.2059 00:00:00',
        original_sum: 140668.9976,
        sum: 140668.9976,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37865,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.03.2059 00:00:00',
        original_sum: 140668.9976,
        sum: 140668.9976,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37866,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.04.2059 00:00:00',
        original_sum: 140668.9976,
        sum: 140668.9976,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 38058,
        goal_id: 282,
        currency_id: 1,
        paid_at: '31.05.2059 00:00:00',
        original_sum: 140668.9976,
        sum: 140668.9976,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37868,
        goal_id: 282,
        currency_id: 1,
        paid_at: '30.06.2059 00:00:00',
        original_sum: 140668.9976,
        sum: 140668.9976,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
    ],
    currency: {
      id: 1,
      name: 'Российский рубль',
      code: 'RUB',
      sign: '₽',
      order: 1,
    },
  },
  {
    id: 281,
    user_id: 876,
    name: 'Подушка',
    comment: null,
    start_at: '06.03.2022 00:00:00',
    end_at: '10.12.2025 00:00:00',
    sum: null,
    future_sum: 0,
    start_sum: 0,
    percent: 0,
    percent_sum: 10,
    payment_per_period: 0,
    currency_id: 1,
    period_type_id: 3,
    type_id: 2,
    next_period_id: 0,
    calc_type_id: null,
    count: 1,
    data: [
      {
        sum: '600000',
        end_at: '2025-12-10',
        payment_per_period: '14486.8779',
        count_payments: '45',
        sum_payments: '732082.0638000006',
        future_sum: '871639.3787376813',
        achive_goal: false,
      },
    ],
    payments: {
      aim_payments_index: [
        '2022-03-31',
        '2022-04-29',
        '2022-05-31',
        '2022-06-30',
        '2022-07-29',
        '2022-08-31',
        '2022-09-30',
        '2022-10-31',
        '2022-11-30',
        '2022-12-30',
        '2023-01-31',
        '2023-02-28',
        '2023-03-31',
        '2023-04-28',
        '2023-05-31',
        '2023-06-30',
        '2023-07-31',
        '2023-08-31',
        '2023-09-29',
        '2023-10-31',
        '2023-11-30',
        '2023-12-29',
        '2024-01-31',
        '2024-02-28',
        '2024-03-29',
        '2024-04-30',
        '2024-05-31',
        '2024-06-28',
        '2024-07-31',
        '2024-08-30',
        '2024-09-30',
        '2024-10-31',
        '2024-11-29',
        '2024-12-31',
        '2025-01-31',
        '2025-02-28',
        '2025-03-31',
        '2025-04-30',
        '2025-05-30',
        '2025-06-30',
        '2025-07-31',
        '2025-08-29',
        '2025-09-30',
        '2025-10-31',
        '2025-11-28',
      ],
      aim_payments_values: [
        14486.8779, 14486.8779, 14486.8779, 14486.8779, 14486.8779, 14486.8779, 14486.8779,
        14486.8779, 14486.8779, 14491.9925, 15413.4721, 15413.4721, 15413.4721, 15413.4721,
        15413.4721, 15413.4721, 15413.4721, 15413.4721, 15413.4721, 15413.4721, 15413.4721,
        15417.0949, 16785.2491, 16785.2491, 16785.2491, 16785.2491, 16785.2491, 16785.2491,
        16785.2491, 16785.2491, 16785.2491, 16785.2491, 16785.2491, 16794.839, 18255.4821,
        18255.4821, 18255.4821, 18255.4821, 18255.4821, 18255.4821, 18255.4821, 18255.4821,
        18255.4821, 18255.4821, 18255.4821,
      ],
    },
    inflation: 10,
    spending_per_period: 0,
    spending_per_period_future: null,
    order: 3,
    plan_type_id: 1,
    bind_type_id: 1,
    consider_type_id: 1,
    retire_id: 3,
    scenario_id: 4,
    portfolio_plan: null,
    advise: {
      buy_1: [],
      buy_2: [],
      sell_1: [],
      sell_2: [],
    },
    plan_fields: null,
    goal_payments: [
      {
        id: 37869,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.03.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37914,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.04.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37871,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.05.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37872,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.06.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37915,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.07.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37874,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.08.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37875,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.09.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37876,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.10.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37877,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.11.2022 00:00:00',
        original_sum: 14486.8779,
        sum: 14486.8779,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37916,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.12.2022 00:00:00',
        original_sum: 14491.9925,
        sum: 14491.9925,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37879,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.01.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37880,
        goal_id: 281,
        currency_id: 1,
        paid_at: '28.02.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37881,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.03.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37917,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.04.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37883,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.05.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37884,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.06.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37885,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.07.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37886,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.08.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37918,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.09.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37888,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.10.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37889,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.11.2023 00:00:00',
        original_sum: 15413.4721,
        sum: 15413.4721,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37919,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.12.2023 00:00:00',
        original_sum: 15417.0949,
        sum: 15417.0949,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37891,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.01.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37892,
        goal_id: 281,
        currency_id: 1,
        paid_at: '28.02.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37920,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.03.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37894,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.04.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37895,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.05.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37921,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.06.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37897,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.07.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37922,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.08.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37899,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.09.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37900,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.10.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37923,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.11.2024 00:00:00',
        original_sum: 16785.2491,
        sum: 16785.2491,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37902,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.12.2024 00:00:00',
        original_sum: 16794.839,
        sum: 16794.839,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37903,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.01.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37904,
        goal_id: 281,
        currency_id: 1,
        paid_at: '28.02.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37905,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.03.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37906,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.04.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37924,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.05.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37908,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.06.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37909,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.07.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37925,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.08.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37911,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.09.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37912,
        goal_id: 281,
        currency_id: 1,
        paid_at: '31.10.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 37926,
        goal_id: 281,
        currency_id: 1,
        paid_at: '30.11.2025 00:00:00',
        original_sum: 18255.4821,
        sum: 18255.4821,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
    ],
    currency: {
      id: 1,
      name: 'Российский рубль',
      code: 'RUB',
      sign: '₽',
      order: 1,
    },
  },
  {
    id: 279,
    user_id: 876,
    name: 'Отдых',
    comment: null,
    start_at: '06.10.2021 00:00:00',
    end_at: '10.03.2022 00:00:00',
    sum: null,
    future_sum: null,
    start_sum: null,
    percent: 0,
    percent_sum: 0,
    payment_per_period: 0,
    currency_id: 1,
    period_type_id: 3,
    type_id: 1,
    next_period_id: 0,
    calc_type_id: null,
    count: 2,
    data: [
      {
        sum: '60000',
        end_at: '2022-08-10',
        future_sum: '60000',
        count_payments: 0,
        sum_payments: 0,
        payment_per_period: 6000,
      },
      {
        sum: '70000',
        end_at: '2022-03-10',
        future_sum: '70000',
        payment_per_period: 0,
      },
    ],
    payments: {
      aim_payments_index: [
        '2021-11-06',
        '2021-12-06',
        '2022-01-06',
        '2022-02-06',
        '2022-03-06',
        '2022-04-06',
        '2022-05-06',
        '2022-06-06',
        '2022-07-06',
        '2022-08-06',
      ],
      aim_payments_values: [6000, 6000, 6000, 6000, 6000, 6000, 6000, 6000, 6000, 6000],
    },
    inflation: 0,
    spending_per_period: 0,
    spending_per_period_future: null,
    order: 1,
    plan_type_id: 2,
    bind_type_id: 1,
    consider_type_id: 1,
    retire_id: 3,
    scenario_id: 4,
    portfolio_plan: null,
    advise: {
      buy_1: [],
      buy_2: [],
      sell_1: [],
      sell_2: [],
    },
    plan_fields: null,
    goal_payments: [
      {
        id: 36378,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.11.2021 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36379,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.12.2021 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36380,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.01.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36381,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.02.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36382,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.03.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36383,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.04.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36384,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.05.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36385,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.06.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36386,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.07.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36387,
        goal_id: 279,
        currency_id: 1,
        paid_at: '06.08.2022 00:00:00',
        original_sum: 6000,
        sum: 6000,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
    ],
    currency: {
      id: 1,
      name: 'Российский рубль',
      code: 'RUB',
      sign: '₽',
      order: 1,
    },
  },
  {
    id: 278,
    user_id: 876,
    name: 'Отпуск',
    comment: null,
    start_at: '05.11.2020 00:00:00',
    end_at: '15.06.2021 00:00:00',
    sum: null,
    future_sum: 0,
    start_sum: 5000,
    percent: 0,
    percent_sum: 4,
    payment_per_period: 0,
    currency_id: 1,
    period_type_id: 3,
    type_id: 1,
    next_period_id: 0,
    calc_type_id: null,
    count: 2,
    data: [
      {
        sum: '60000',
        end_at: '2021-04-25',
        payment_per_period: 10926.910703435433,
        count_payments: 2,
        sum_payments: 49916.80532445754,
        future_sum: '60000',
      },
      {
        sum: '55000',
        end_at: '2021-06-15',
        payment_per_period: 24958.40266222877,
        future_sum: '55000',
      },
    ],
    payments: {
      aim_payments_index: [
        '2020-12-05',
        '2021-01-05',
        '2021-02-05',
        '2021-03-05',
        '2021-04-05',
        '2021-04-25',
        '2021-05-25',
      ],
      aim_payments_values: [
        10926.910703435433, 10926.910703435433, 10926.910703435433, 10926.910703435433,
        10926.910703435433, 24958.40266222877, 24958.40266222877,
      ],
    },
    inflation: 0,
    spending_per_period: 0,
    spending_per_period_future: null,
    order: 0,
    plan_type_id: 2,
    bind_type_id: 1,
    consider_type_id: 1,
    retire_id: 3,
    scenario_id: 4,
    portfolio_plan: null,
    advise: {
      buy_1: [],
      buy_2: [],
      sell_1: [['cash', ['rub', 10000]]],
      sell_2: [],
    },
    plan_fields: null,
    goal_payments: [
      {
        id: 36916,
        goal_id: 278,
        currency_id: 1,
        paid_at: '05.12.2020 00:00:00',
        original_sum: 10926.91070343,
        sum: 10926.91070343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36917,
        goal_id: 278,
        currency_id: 1,
        paid_at: '05.01.2021 00:00:00',
        original_sum: 10926.91070343,
        sum: 10926.91070343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36918,
        goal_id: 278,
        currency_id: 1,
        paid_at: '05.02.2021 00:00:00',
        original_sum: 10926.91070343,
        sum: 10926.91070343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36919,
        goal_id: 278,
        currency_id: 1,
        paid_at: '05.03.2021 00:00:00',
        original_sum: 10926.91070343,
        sum: 10926.91070343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36920,
        goal_id: 278,
        currency_id: 1,
        paid_at: '05.04.2021 00:00:00',
        original_sum: 10926.91070343,
        sum: 10926.91070343,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36921,
        goal_id: 278,
        currency_id: 1,
        paid_at: '25.04.2021 23:59:59',
        original_sum: 24958.40266223,
        sum: 24958.40266223,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
      {
        id: 36922,
        goal_id: 278,
        currency_id: 1,
        paid_at: '25.05.2021 23:59:59',
        original_sum: 24958.40266223,
        sum: 24958.40266223,
        original_paid_sum: 0,
        paid_sum: 0,
        is_confirmed: false,
        is_active: 1,
        currency: {
          id: 1,
          name: 'Российский рубль',
          code: 'RUB',
          sign: '₽',
          order: 1,
        },
      },
    ],
    currency: {
      id: 1,
      name: 'Российский рубль',
      code: 'RUB',
      sign: '₽',
      order: 1,
    },
  },
];

export default data;
